import { Text } from "components/atoms/text/Text";
import styled from "styled-components";
import { COLORS } from "styles/colors";
import { FLEX } from "styles/flex";
import NoDataIcon from "assets/images/no_data_icon.png";
import NoDataLightIcon from "assets/images/no_data_icon_light.png";
import { useAppSelector } from "redux/hooks";
import * as mediaQuery from "components/MediaQuery";

interface Props {
  theme?: "light" | "dark";
}
export default function NoData(props: Props): JSX.Element {
  const themeValue = useAppSelector((state) => state.theme.theme);
  const themeMode = props.theme ? props.theme : themeValue;
  return (
    <Wrapper className="no-data" themeMode={themeMode}>
      {themeMode === "light" ? (
        <img src={NoDataLightIcon} alt="no_data_icon" />
      ) : (
        <img src={NoDataIcon} alt="no_data_icon" />
      )}
      <Text bold>There is no data to display</Text>
    </Wrapper>
  );
}

const Wrapper = styled.div<{ themeMode: "light" | "dark" }>`
  width: 100%;
  ${FLEX.FlexCenterCenter};
  flex-direction: column;
  /* padding: 30px 0;
  height: 100%; */
  gap: 6px;

  img {
    width: 70px;
    max-width: 70px !important;
  }

  * {
    color: ${({ themeMode }) =>
      themeMode === "light" ? COLORS.BLACK : COLORS.BORDER};
  }

  ${mediaQuery.isMobile} {
    img {
      width: 50px;
      max-width: 50px !important;
    }
  }
`;
